import { Box, useTheme } from "@mui/material";
import { alpha } from '@mui/material/styles';

const HeroImage = () => {
    const theme = useTheme();

    return (
        <>
            <Box
                data-aos="fade-zoom-in"
            >
                <img 
                    src="/images/hero/hero.jpg" 
                    alt="World map" 
                    width='100%'
                    style={{
                        borderRadius: '16px'
                    }}
                />

                {/* Gradient overlay */}
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "99%",
                        background: `linear-gradient(${alpha(theme.palette.primary.main, 0.4)} 1%, rgba(255,255,255,0) 75%, rgba(255,255,255,1))`,
                        pointerEvents: "none",
                        borderRadius: '16px'
                    }}
                />
            </Box>
        </>
    );
}

export default HeroImage;